import { actions } from '../constants/forum';
import * as actionTypes from '../../models/action/forum';
import { IAuthInformation, IAction } from '../../models/action/core';
import { Log } from 'ng2-logger';
import { ForumThreadType } from '../../models/enums/forumThreadType';
import { date } from 'yup';
import { ICreateForumData } from '../../models/components/create-forum';
import { IForumMessage } from '../../models/components/forum-message';

const _logger = Log.create('ForumActions');

export function getHomePageConversationGetAction(Filters: actionTypes.IFilters, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetHomePageConversation {
    return {
        Filters,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MY_GROUP
    };
}

export function setHomePageConversationSetAction(homePageConversation: actionTypes.IConversation[] | null, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetHomePageConversation {
    return {
        homePageConversation,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MY_GROUP
    };
}

export function getForumConversation(take: number, skip: number, forumType: ForumThreadType, classId: string, spinnerId: string, spinnerType?: 'get' | 'set', searchedWord?: string, callback?: (value: boolean) => void, spinnerIds?: any, courseId?: string): actionTypes.IGetForumConversation {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_GET_CONVERSION,
        take,
        skip,
        forumType,
        classId,
        spinnerId,
        spinnerType,
        searchedWord,
        callback,
        spinnerIds,
        courseId
    };
}

export function addForumActivityGetAction(forumData: actionTypes.IForumData, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: any) => void): actionTypes.IGetAddForum {
    return {
        forumData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.ADD_FORUM_ACTIVITY_GET,
        callback
    };
}

export function getForumData(params: actionTypes.IGetForumActivityActionParams, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.IGetForumActivityData {
    return {
        ...params,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_FORUM_DATA
    };
}

export function setForumData(activityData: actionTypes.ISetForumActivityDataParams, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetForumActivityData {
    return {
        ...activityData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_FORUM_DATA
    };
}

export function setForumDataDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_FORUM_DATA_DEFAULT
    };
}

export function setForumConversation(forumConversation: actionTypes.IConversation[] | null, take: number, skip: number, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetForumConversation {
    return {
        skip,
        take,
        spinnerId,
        spinnerType,
        forumConversation,
        timestamp: Date.now(),
        type: actions.FORUM_SET_CONVERSION
    };
}

export function addForum(addForumData: ICreateForumData, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: boolean) => void): actionTypes.IAddForum {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_ADD,
        addForumData,
        spinnerId,
        spinnerType,
        callback
    };
}



export function getForumMessage(forumThreadId: string, forumSubject: string, skip: number, take: number, spinnerId?: string, spinnerType?: 'get' | 'set', searchedWord?: any, isAll?: boolean, callback?: any, messageId?: string, activityId?: string): actionTypes.IGetForumMessage {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_GET_FORUMMESSAGE,
        forumThreadId,
        skip,
        take,
        spinnerId,
        spinnerType,
        forumSubject,
        searchedWord,
        isAll,
        messageId,
        callback,
        activityId
    };
}

export function setForumMessage(forumMessages: IForumMessage[], forumThreadId: string, forumSubject: string, skip: number, take: number, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetForumMessage {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_SET_FORUMMESSAGE,
        spinnerType,
        spinnerId,
        forumMessages,
        forumThreadId,
        skip,
        take,
        forumSubject,
    };
}

export function setForumMessageDefault(spinnerId?: string, spinnerType?: 'get' | 'set'): IAction {
    return {
        timestamp: Date.now(),
        type: actions.SET_DEFAULT_MESSAGE_DATA,
        spinnerType,
        spinnerId
    };
}

export function setMessageAnswers(messageId: string, answers: IForumMessage[], forumThreadId: string, skip: number, take: number, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetAnswers {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_SET_ANSWERS,
        spinnerType,
        spinnerId,
        answers,
        forumThreadId,
        skip,
        take,
        messageId
    };
}

export function getForumThreadById(forumThreadId: string, spinnerId: string, spinnerType?: 'get' | 'set'): actionTypes.IGetForumThreadById {
    return {
        type: actions.FORUM_GET_THREADBYID,
        timestamp: Date.now(),
        forumThreadId,
        spinnerId,
        spinnerType
    };
}

export function setForumThreadById(forumData: ICreateForumData, spinnerId: string, spinnerType?: 'get' | 'set'): actionTypes.ISetForumThreadById {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_SET_THREADBYID,
        forumData,
        spinnerId,
        spinnerType
    };
}

export function sendForumMessageByThreadId(message: string, threadId: string, subject: string, messageId?: string, fileUploadId?: string, callback?: any): actionTypes.ISendForumMessage {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_SEND_MESSAGE,
        message,
        threadId,
        subject,
        messageId,
        fileUploadId,
        callback
    };
}

export function answerMessageGetAction(message: string, threadId: string, messageId: string, subject: string, isUpdate?: boolean, callback?: any, fileUploadId?: string, deletedFiles?: any): actionTypes.ISendAnswer {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_SEND_ANSWER,
        message,
        threadId,
        messageId,
        subject,
        isUpdate,
        callback,
        fileUploadId,
        deletedFiles
    };
}

export function deleteAnswerMessageGetAction(threadId: string, messageId: string, deleteType: number, subject?: string, callback?: any): actionTypes.IDeleteMessage {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_DELETE_ANSWER,
        threadId,
        messageId,
        deleteType,
        subject,
        callback
    };
}

export function deleteForum(forumThreadId: string, activityId: string, classId: string, courseId?: string): actionTypes.IDeleteForum {
    return {
        timestamp: Date.now(),
        type: actions.FORUM_DELETE,
        activityId,
        classId,
        forumThreadId,
        courseId
    };
}

export function getMessageData(threadId: string, messageId: string, subject?: string, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IGetMessageData {
    return {
        threadId,
        messageId,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.GET_MESSAGE_DATA,
        callback,
        subject
    };
}

export function setMessageData(messageData: IForumMessage, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetMessageData {
    return {
        messageData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MESSAGE_DATA
    };
}

export function ratingMessage(ratingMessageData: actionTypes.IRatingMessage, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IGetRatingMessage {
    return {
        ratingMessageData,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        callback,
        type: actions.FORUM_RATING_MESSAGE
    };
}

export function updateForumMessageStatus(messageData: IForumMessage, isApproved: boolean, spinnerId?: string, spinnerType?: 'get' | 'set', callback?: any): actionTypes.IUpdateForumMessage {
    return {
        messageData,
        isApproved,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        callback,
        type: actions.UPDATE_FORUM_MESSAGE
    };
}

export function setForumMessageUpdateData(messageData: IForumMessage,isApproved: boolean, spinnerId?: string, spinnerType?: 'get' | 'set'): actionTypes.ISetMessageUpdateData {
    return {
        messageData,
        isApproved,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.SET_MESSAGE_UPDATE_DATA
    };
}

